import {useQuery} from '@apollo/react-hooks';

import type {
    SalesAutomationableEmailSequenceTemplates,
    SalesAutomationableEmailSequenceTemplatesVariables,
    SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates,
} from 'nutshell-graphql-types';

import GET_SALES_AUTOMATIONABLE_EMAIL_SEQUENCES from '../../../core/select/queries/sales-automationable-email-sequence-templates.graphql';

export const useGetSalesAutomationableEmailTemplates = (
    stagesetId: string | undefined
): {
    isLoading: boolean;
    templates: SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates[];
} => {
    const {loading, data} = useQuery<
        SalesAutomationableEmailSequenceTemplates,
        SalesAutomationableEmailSequenceTemplatesVariables
    >(GET_SALES_AUTOMATIONABLE_EMAIL_SEQUENCES, {
        variables: {stagesetId},
        skip: !stagesetId,
    });

    return {
        isLoading: loading,
        templates: data?.salesAutomationableEmailSequenceTemplates ?? [],
    };
};
